'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'square-6';
var width = 448;
var height = 512;
var aliases = [];
var unicode = 'e25b';
var svgPathData = ['M16 96l0 320c0 26.5 21.5 48 48 48l320 0c26.5 0 48-21.5 48-48l0-320c0-26.5-21.5-48-48-48L64 48C37.5 48 16 69.5 16 96zM152 216c0-30.9 25.1-56 56-56l40 0c4.4 0 8 3.6 8 8s-3.6 8-8 8l-40 0c-22.1 0-40 17.9-40 40l0 35.2c11-11.8 26.6-19.2 44-19.2l24 0c33.1 0 60 26.9 60 60s-26.9 60-60 60l-24 0c-31 0-56.6-23.5-59.7-53.7-.2-.7-.3-1.5-.3-2.3l0-80zm16 76c0 24.3 19.7 44 44 44l24 0c24.3 0 44-19.7 44-44s-19.7-44-44-44l-24 0c-24.3 0-44 19.7-44 44z', 'M64 48C37.5 48 16 69.5 16 96l0 320c0 26.5 21.5 48 48 48l320 0c26.5 0 48-21.5 48-48l0-320c0-26.5-21.5-48-48-48L64 48zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm256 72c0 4.4-3.6 8-8 8l-40 0c-22.1 0-40 17.9-40 40l0 35.2c11-11.8 26.6-19.2 44-19.2l24 0c33.1 0 60 26.9 60 60s-26.9 60-60 60l-24 0c-31 0-56.6-23.5-59.7-53.7-.2-.7-.3-1.5-.3-2.3l0-80c0-30.9 25.1-56 56-56l40 0c4.4 0 8 3.6 8 8zM212 336l24 0c24.3 0 44-19.7 44-44s-19.7-44-44-44l-24 0c-24.3 0-44 19.7-44 44s19.7 44 44 44z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faSquare6 = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;